"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Components = void 0;
var Components;
exports.Components = Components;
(function (Components) {
  Components["Logo"] = "logo";
  Components["BestProductsLogo"] = "bestProductsLogo";
  Components["Label"] = "label";
  Components["License"] = "license";
  Components["Button"] = "button";
  Components["DetailsToggle"] = "detailsToggle";
  Components["Range"] = "range";
  Components["MoreButton"] = "moreButton";
  Components["StaticNumber"] = "staticNumber";
  Components["StaticString"] = "staticString";
  Components["StaticDate"] = "staticDate";
  Components["Caption"] = "caption";
  Components["Tags"] = "tags";
  Components["SubCaption"] = "subCaption";
  Components["MiddleCaption"] = "middleCaption";
  Components["HorizontalLine"] = "horizontalLine";
  Components["Rating"] = "rating";
  Components["Dictionary"] = "dictionary";
  Components["Disclaimer"] = "disclaimer";
})(Components || (exports.Components = Components = {}));